export default __webpack_public_path__ + "static/media/Storm_9781843626374.d7e53bec.jpg";